import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { TextColors } from '@picsart/design-system/foundation/colors';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const ILLUSTRATION_SIZE = 120;

const useStyles = createUseStyles(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: Spacings.s8,
      padding: [Spacings.s32, Spacings.s24],
      textAlign: 'center',
    },
    illustration: {
      width: ILLUSTRATION_SIZE,
      height: ILLUSTRATION_SIZE,
      marginBottom: Spacings.s8,
    },
    title: {
      fontSize: FontSizes.t5,
      lineHeight: `${LineHeights.t5}px`,
      fontWeight: FontWeights.semibold,
      color: TextColors.base,
    },
    description: {
      fontSize: FontSizes.t4,
      lineHeight: `${LineHeights.t4}px`,
      color: TextColors.tint2,
    },
    retryButton: {
      marginTop: Spacings.s8,
    },
  },
  { name: 'search-empty' }
);

export default useStyles;
